
import { defineComponent } from 'vue'
import styleDescriptor from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesignerDescriptor.json'
import Checkbox from 'primevue/checkbox'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'

export default defineComponent({
    components: { Checkbox, Column, DataTable, Dropdown },
    emits: ['filtersValidationChanged'],
    props: {
        documentDataProp: { type: Object as any, required: false }
    },
    computed: {
        crossDisabled(): any {
            return !this.visibilityControls.showRightConfigMenu || !this.documentDataProp.visibilityData.crossNavigation
        },
        filtersInvalid() {
            if (this.filtersContainEmptyFields) {
                return true
            } else return false
        },
        filtersContainEmptyFields() {
            let value = false
            this.documentDataProp.filters.forEach((field) => {
                if (!field.name || !field.label || field.label === '') {
                    value = true
                } else value = false
            })
            return value
        }
    },
    data() {
        return {
            styleDescriptor,
            documentData: {} as any,
            visibilityControls: {} as any,
            crossNavigationMultiselect: null
        }
    },
    created() {
        this.documentData = this.documentDataProp
        this.visibilityControls = this.documentDataProp.visibilityData.visibilityControls
        this.crossNavigationMultiselect = this.documentDataProp.visibilityData.crossNavigationMultiselect
        this.$emit('filtersValidationChanged', 'filtersInvalid', this.filtersInvalid)
    },
    watch: {
        documentDataProp() {
            this.documentData = this.documentDataProp
        },
        filtersInvalid() {
            this.$emit('filtersValidationChanged', 'filtersInvalid', this.filtersInvalid)
        }
    },
    methods: {
        addFilterRow() {
            this.documentData.filters.push({ name: null, label: null })
        },
        deleteFilterRow(eventData) {
            this.documentData.filters.splice(eventData.index, 1)
        }
    }
})
